import autosize from 'autosize';

const FormTextareaAutosizeHook = {
  mounted() {
    autosize(this.el);
  },

  updated() {
    autosize.update(this.el);
  },
};

export default FormTextareaAutosizeHook;
